import { computed, ref } from 'vue';
import { BaseState } from '@ilteducation/content-registry-types/enums/content-enums';
import type { MaterialV1 } from '@ilteducation/content-registry-types';
import mediaProvider, { type UploadParams } from '@/data-provider/mediaProvider';

const useMaterial = () => {
  const toggleStateInProgress = ref(false);
  const uploadInProgress = ref(false);
  const removeInProgress = ref(false);

  const uploadMedia = async (id: string, data: File, params: UploadParams = {}) => {
    uploadInProgress.value = true;
    await mediaProvider.uploadMedia(id, data, params);
    uploadInProgress.value = false;
  };

  const toggleMediaState = async (item: MaterialV1) => {
    const isPublished = item?.state === BaseState.Published;
    toggleStateInProgress.value = true;
    await mediaProvider
      .toggleMediaState(item?.id, isPublished)
      .then(() => {
        // eslint-disable-next-line no-param-reassign
        item.state = isPublished ? BaseState.Disabled : BaseState.Published;
      })
      .then(() => {
        toggleStateInProgress.value = false;
      });
  };

  const getStateColor = (state: BaseState) => {
    switch (state) {
      case BaseState.Published:
        return 'success';
      case BaseState.Disabled:
        return 'error';
      default:
        return 'warning';
    }
  };

  const getStateIcon = (state: BaseState) => {
    switch (state) {
      case BaseState.Published:
        return 'mdi-checkbox-marked';
      case BaseState.Disabled:
        return 'mdi-close-box';
      default:
        return 'mdi-new-box';
    }
  };

  return {
    isStateInProgress: computed(() => toggleStateInProgress.value),
    isUploadInProgress: computed(() => uploadInProgress.value),
    isRemoveInProgress: computed(() => removeInProgress.value),
    uploadMedia,
    toggleMediaState,
    getStateColor,
    getStateIcon,
  };
};

export default useMaterial;
